/**
 * Splash — mirrors the inline HTML splash in index.html so the loading
 * experience is seamless across the handoff from index.html to React.
 *
 * AppContent returns null while auth bootstraps (getSession + profile
 * fetch, 200ms-2s on slow networks). The instant React mounts it
 * replaces the index.html splash with whatever the App renders, so
 * returning null leaves the user staring at a blank screen until auth
 * resolves. Rendering this component keeps an identical spinner +
 * copy visible across that gap.
 *
 * Visuals match the HTML splash byte-for-byte: same background colour,
 * same violet spinner ring, same copy, same animation. Uses the
 * @keyframes sp already declared in index.html so no extra CSS is
 * required.
 */
export default function Splash() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'var(--color-bg)',
        fontFamily: 'Inter, system-ui, sans-serif',
      }}
    >
      <div
        style={{
          width: 40,
          height: 40,
          border: '3px solid #e2e8f0',
          borderTopColor: 'var(--color-primary)',
          borderRadius: '50%',
          animation: 'sp .8s linear infinite',
        }}
      />
      <p
        style={{
          margin: '1rem 0 0',
          fontSize: 'var(--text-base)',
          color: 'var(--color-text-light)',
          fontWeight: 500,
        }}
      >
        Loading CleanMyBed
      </p>
      <p
        style={{
          margin: '0.25rem 0 0',
          fontSize: 'var(--text-sm)',
          color: 'var(--color-text-light)',
        }}
      >
        Just a moment...
      </p>
    </div>
  );
}
